import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ip-shared-colored-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './colored-card.component.html',
  styleUrl: './colored-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColoredCardComponent {
  @Input() backgroundStyleType = 'background-image';
  @Input() backgroundStyle = 'linear-gradient(to right, rgba(91, 47, 117, 0.8), rgba(54, 86, 171, 0.8)';
  @Input() boxShadow = false;

  style: { [p: string]: string } = {};

  constructor() {
    this.style[this.backgroundStyleType] = this.backgroundStyle;
    if (this.boxShadow) this.style['box-shadow'] = 'rgba(0, 0, 0, 0.35) 0 5px 15px';
  }
}
